import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'da_DK',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '28d436bd-5e82-40b0-ba59-954d5e2e0953',
  ''
);
